export const APP_INIT = 'APP_INIT'
export const appInit = () => ({
  type: APP_INIT
})
